module.exports = __webpack_public_path__ + "img/promo_tablet.3fb4b2f.jpg";